import React, { useState, useEffect } from "react";
import AppRouter from "./routers/AppRouter";
import GoogleSignIn from "./components/GoogleSignIn";
import * as api from "./lib/api";

import { Provider } from "react-redux";
import { store } from "./store/configureStore";

import "./styles.scss";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    let cancelled = false;
    api.verifySession()
      .then((ok) => {
        if (cancelled) return;
        setIsAuthenticated(ok);
        setIsChecking(false);
      })
      .catch(() => {
        if (cancelled) return;
        setIsAuthenticated(false);
        setIsChecking(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (isChecking) {
    return (
      <div className="App">
        <div className="app-boot">Loading...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <div className="App">
        <GoogleSignIn onSuccess={() => setIsAuthenticated(true)} />
      </div>
    );
  }

  return (
    <div className="App">
      <Provider store={store}>
        <AppRouter />
      </Provider>
    </div>
  );
}

export default App;
